import React, {Fragment} from 'react'
import { Div, Title, SubTitle, DivTitle, QuestionsCollapseta, PanelQuestion } from './styles';



export const Preguntas = () => {

  const questions = [
    {
      id: 1,
      question: '¿Qué productos puedo comprar en Kôra?',
      awnser: 'Manejamos actualmente dos líneas; una línea Capilar y una Facial. Próximamente sacaremos nuevas líneas para llevar más experiencia para el cuidado de la belleza.',
    },
    {
      id: 2,
      question: '¿Los productos incluyen el domicilio?',
      awnser: 'No, el cliente debe responder por este costo. Sin embargamos manejamos promoción, te invito leas nuestra página.',
    },
    {
      id: 3,
      question: '¿En cuanto tiempo puedo recibir mi pedido?',
      awnser: 'Se realizará con un intervalo de 2 a tres días después de su compra.',
    },
    {
      id: 4,
      question: '¿Qué beneficios tiene el caolín en la piel?',
      awnser: 'El caolín es un tipo especial de arcilla que tiene la cualidad de limpiar a profundidad nuestra piel, que cuenta con un gran poder para absorber las impurezas; como las que son causadas por la polución y el exceso de grasa; además, es un exfoliante natural muy suave, el cual no causa irritación, por el contrario, la alivia, mientras elimina las células muertas, esto nos da una apariencia más limpia y sana en el rostro.',
    },
    {
      id: 5,
      question: '¿Cuántas veces a la semana debo utilizar el exfoliante facial?',
      awnser: 'Lo más recomendable es utilizarlo una, máximo dos veces por semana, para no estimular demasiado las glándulas sebáceas.',
    },
    {
      id: 6,
      question: '¿El exfoliante de Kôra Cosmetics, puede ser utilizado por cualquier tipo de piel?',
      awnser: 'Si, nuestro exfoliante puede ser utilizado por cualquier tipo de piel, como mascarilla y exfoliante al mismo tiempo.',
    },
    {
      id: 7,
      question: '¿Por qué nuestro astringente facial, también es aclarante?',
      awnser: 'Nuestro astringente se caracteriza por tener activos aclarantes completamente naturales, por esta razón se debe ser muy constante, utilizándolo más de 4 veces por semana, para así, disminuir el tamaño de los poros y a su vez unificar el tono de la piel.',
    },
    {
      id: 8,
      question: '¿Para qué tipo de piel está formulado el astringente aclarante?',
      awnser: 'Está formulado para mixtas a grasas, no se recomienda para pieles secas.',
    },
    {
      id: 9,
      question: '¿Qué le sucede a la piel cuando empiezo a utilizar cosméticos con ácido salicílico?',
      awnser: 'Es normal que al empezar a utilizar productos con ácido salicílico haya brotes de acné leves porque la piel se está limpiando para después mantenerse libre de bacterias.',
    },
    {
      id: 10,
      question: '¿Qué ventajas tiene los activos a base de aceites naturales en el tratamiento para el cabello?',
      awnser: 'Estos aceites naturales como el aceite de argán y el aceite de almendras presentes en el tratamiento para el cabello de Kôra Cosmetics, funcionan como un blindaje natural para el cabello, contra agentes agresivos, como el calor y la polución. También se caracterizan por brindar hidratación y por su alto contenido de antioxidantes evita el envejecimiento de la fibra capilar.',
    },
    {
      id: 11,
      question: '¿Para qué sirven las proteínas en el cabello?',
      awnser: 'Las proteínas en el cabello, igual que en los músculos, tienen funciones esenciales por ser parte de la estructura de estos. Funciones como: proteger el cabello y ayudar en su crecimiento, son algunas de las más importantes; en los tratamientos para el cabello están especialmente presentas para tratar cabellos que han sido expuestos a químicos como tintes, decoloraciones, alisados o por daño térmico (altas temperaturas).',
    },
  ]

    return (
      <Fragment>
          <Div>
            <DivTitle>
              <Title>Preguntas Frecuentes</Title>
              <SubTitle>Acá podrás encontrar información importante que debes tener en cuenta para tu cuidado personal.</SubTitle>
            </DivTitle>
            <QuestionsCollapseta accordion>
              {questions.map( question => 
                  <PanelQuestion header={question.question} key={question.id}>
                    <p>{question.awnser}</p>
                  </PanelQuestion>
                )}
            </QuestionsCollapseta>
          </Div>
      </Fragment>
    )
  }